//uses customSelect Plugin => https://kvlsrg.github.io/jquery-custom-select/
import API from './api';
import { capFirstLetter } from './utils';

class Resources extends API {
    tmpl_endpoint = '/wp-json/wp/v2/resource-template'
    api_endpoint = '/wp-json/wp/v2/resource'
    resultsContainer = $('.results__results')
    paginationContainer = $('.results__pagination')
    itemTmpl = null
    preFilter = null

    constructor() {
        super()
        this.getTemplate(this.tmpl_endpoint)   
    }

    async getTemplate(tmpl) {
        this.itemTmpl = await this.fetchTemplate(tmpl)
        this.initFormHandling()

        if(this.hasFilter()) {
            this.selectFilter()
            this.loadResources(this.searchContainer.serializeArray())
        }
        else {
            this.loadResources([], null, false)
        }
    }

    hasFilter() {
        this.preFilter = new URLSearchParams(window.location.search)
        return this.preFilter.has('audience') || this.preFilter.has('type')
    }

    selectFilter() {
        if(this.preFilter.has('audience')) {
            let audience = $('select.audience')
            let audience_val = this.preFilter.get('audience')

            audience.val(audience_val)
            $('.search__audience .custom-select__option--value').text(capFirstLetter(audience_val))
        }

        if(this.preFilter.has('type')) {
            let type = $(`input[name="type[]"][value="${capFirstLetter(this.preFilter.get('type'))}"]`)
            type.prop( "checked", true)
            type.trigger('change')
        }
    }

    initFormHandling() {
        let _t = this

        _t.searchContainer.on('submit', function(e) {
            e.preventDefault()
            _t.searchContainer.find('.multi-select .label').removeClass('open').next('.multi-select-dropdown').fadeOut(200);
            _t.loadResources($(this).serializeArray(), 1)
        })

        _t.paginationContainer.on('click', 'a', function(e) {
            e.preventDefault()
            let page = $(this).data('page')
            _t.loadResources(_t.searchContainer.serializeArray(), page)
        })

        _t.sort.on('change', function() {
            _t.loadResources(_t.searchContainer.serializeArray(), 1)
        })
    }

    async loadResources(formData = [], page = 1, scroll = true) {
        let _t = this
        let queryParams = { page: page }

        if(scroll) _t.scrollToTop()
        _t.resultsContainer.empty().append('<div class="loader"></div>')
        
        formData.forEach(item => {
            if(item.value !== 'null' && item.value !== '') {
                if (queryParams[item.name]) {
                    queryParams[item.name].push(item.value)
                } else {
                    queryParams[item.name] = [item.value]
                }
            }
        })

        let sortOrder = _t.sort.val();
        if (sortOrder) queryParams['sort'] = sortOrder

        _t.fetchAPI(_t.api_endpoint, queryParams)
            .then(response => {
                $('.results__count').html(response.total + ' Resource(s)')
                _t.renderResources(response.resources)
                _t.renderPagination(response.total_pages, response.current_page)
            })
            .catch(err => {
                console.error('Failed to load resources', err)
                _t.resultsContainer.empty().append('<p>Failed to load resources.</p>')
            })
    }

    renderResources(resources) {
        this.resultsContainer.empty()

        if (resources.length > 0) {
            resources.forEach(resource => {
                let link = (resource.format === 'url' && resource.link_direct) ? resource.format_value : resource.link;
                let target = resource.link_direct ? '_blank' : '_self';
                let duration = resource.duration ? resource.duration : false;

                let resourceItem = $(this.itemTmpl
                    .replaceAll('{{title}}', resource.title)
                    .replaceAll('{{href}}', link)
                    .replaceAll('{{target}}', target)
                    .replaceAll('{{image}}', resource.featured_image)
                    .replaceAll('{{type}}', resource.resource_type[0])
                    .replaceAll('{{excerpt}}', resource.excerpt)
                    .replaceAll('{{duration}}', duration + ' min')
                    .replaceAll('{{resource_tags}}', resource.resource_tags.join(', '))
                    .replaceAll('{{classes}}', this.getResourceClass(resource))
                )

                if(!duration) resourceItem.find('.duration').remove()
                if(!resource.featured_image) resourceItem.find('.image img').remove()
                this.resultsContainer.append(resourceItem)
            })
        } else {
            this.resultsContainer.append('<p>No resources found.</p>')
        }
    }

    getResourceClass(resource) {
        let classes = 'resource-item__'

        if (resource.format_value.toLowerCase().endsWith('.pdf')) {
            classes += 'download' 
        }
        else {
            switch(resource.format) {
                case 'podcast' :
                case 'youtube' :
                    classes += 'watch'
                    break
                case 'link':
                    classes += 'view-link'
                    break
                case 'file':
                    classes += 'download'
                    break
                default:
                    classes += 'view-link'
            }
        }
        
        return classes
    }
}

$(() => {
    if ($('.resources').length) new Resources()
})
